import styles from './ContactPage.module.css';

function ContactPage() {
  return (
    <div className={styles.page}>
      <section className={styles.location}>
        <h2 className={styles.label}>Email</h2>
        <p className={styles.value}>drdavisicecream@gmail.com</p>
        <h1 className={styles.locationTitle}>Doc's Pepperell</h1>
        <h2 className={styles.label}>Call</h2>
        <p className={styles.value}>978-433-6315</p>
        <h2 className={styles.label}>Address</h2>
        <p className={styles.value}>67 Hollis Street<br />Pepperell MA, 01463</p>
      </section>

      <section className={styles.location}>
        <h1 className={styles.locationTitle}>Doc's Brookline</h1>
        <h2 className={styles.label}>Call</h2>
        <p className={styles.value}>603-673-6003</p>
        <h2 className={styles.label}>Address</h2>
        <p className={styles.value}>75 Route 13<br />Brookline, NH 03033</p>
      </section>
    </div>
  );
}

export default ContactPage;
